import SEO from "../SEO"
import { useRef } from "react"
import { Navigation } from "../ui/Navigation"
import { PricingPageWrapper } from "./styled"
import {
  OurServices,
  MoreGoodDays,
  OtherWaysToPay,
  HeroTitle,
} from "./sections"
import { organizationSchemaMarkup } from "../../common/OrganizationSeoSchema"
import { SuccessStories } from "../shared"
import { FAQSection, InsuranceWidget, BigHero } from "../shared"
import Hero from "./assets/hero.webp"

export const PricingPageBody = (): JSX.Element => {
  const ourServicesRef = useRef<HTMLDivElement | null>(null)

  const learnMoreClicked = () => {
    if (ourServicesRef.current) {
      const top = ourServicesRef.current.getBoundingClientRect().top
      window.scrollTo({ top: top + window.scrollY - 120, behavior: "smooth" })
    }
  }

  const heroDescription =
    "Personalized therapy and medication treatment plans designed to help you make real progress over time"
  return (
    <PricingPageWrapper>
      <BigHero
        Title={HeroTitle}
        image={Hero}
        learnMoreClicked={learnMoreClicked}
        description={heroDescription}
      />
      <OurServices ref={ourServicesRef} />
      <InsuranceWidget />
      <OtherWaysToPay />
      <SuccessStories />
      <MoreGoodDays />
      <FAQSection labels={["plans_faq"]} />
    </PricingPageWrapper>
  )
}

export const PricingPage = (): JSX.Element => {
  return (
    <>
      <SEO
        title="Pricing"
        titleSuffix="Expert Online Therapy + Mental Health Care on Your Schedule"
        description="Cerebral experts can treat anxiety, depression, insomnia, and more. Learn about the care you can get today."
        url="pricing/"
        schemaMarkup={organizationSchemaMarkup}
      />
      <Navigation />
      <PricingPageBody />
    </>
  )
}
